
/* injects from baggage-loader */

'use strict';

import AccountBankAccountsController from './account.bank-accounts.controller';
import AccountBankAccountsTemplate from './account.bank-accounts.html';

export default class AccountBankAccountsComponent {
		constructor() {
				this.templateUrl = AccountBankAccountsTemplate;
				this.controller = AccountBankAccountsController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					stripeAccount: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/bank-accounts/account.bank-accounts.component.js